export enum PartnerIncomesStatuses {
    NEW = 0,
    COMPLETED = 1,
}